
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as teamM442UbwkSdIRoaJI7s1WHoDmkAgbPX__45bsNWFWsNxJAMeta } from "/vercel/path0/app/pages/team.vue?macro=true";
import { default as indexXNEFQ_45BjAwM6CKVywW7WXWaOQOf9WzaBic0wLTXHAssMeta } from "/vercel/path0/app/pages/index.vue?macro=true";
import { default as karriere_45ejk49WDw4IywqJVAo1_xUN_Ey8Wfx3KS5xJhP_BWiwMeta } from "/vercel/path0/app/pages/karriere.vue?macro=true";
import { default as impressumbOul6tMv7Jl3oyniI_GIa_gGgfT9qjaEv3jNH7QbyT4Meta } from "/vercel/path0/app/pages/impressum.vue?macro=true";
import { default as leistungenEOr7vzbx9aOuqGU9ZEzk5eGuDSSSJpxXPZ_45AI5JF5MMMeta } from "/vercel/path0/app/pages/leistungen.vue?macro=true";
import { default as referenzenjLVV7mK3m_45Phy7xTTeViUW35BzKseBvL1MdB0qRSEL0Meta } from "/vercel/path0/app/pages/referenzen.vue?macro=true";
import { default as datenschutz6OJtqLa28KpB6JIiElYAAcZ1vKHXBOpzFdze8UySUtMMeta } from "/vercel/path0/app/pages/datenschutz.vue?macro=true";
export default [
  {
    name: "team",
    path: "/team",
    meta: teamM442UbwkSdIRoaJI7s1WHoDmkAgbPX__45bsNWFWsNxJAMeta || {},
    component: () => import("/vercel/path0/app/pages/team.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexXNEFQ_45BjAwM6CKVywW7WXWaOQOf9WzaBic0wLTXHAssMeta || {},
    component: () => import("/vercel/path0/app/pages/index.vue")
  },
  {
    name: "karriere",
    path: "/karriere",
    meta: karriere_45ejk49WDw4IywqJVAo1_xUN_Ey8Wfx3KS5xJhP_BWiwMeta || {},
    component: () => import("/vercel/path0/app/pages/karriere.vue")
  },
  {
    name: "impressum",
    path: "/impressum",
    meta: impressumbOul6tMv7Jl3oyniI_GIa_gGgfT9qjaEv3jNH7QbyT4Meta || {},
    component: () => import("/vercel/path0/app/pages/impressum.vue")
  },
  {
    name: "leistungen",
    path: "/leistungen",
    meta: leistungenEOr7vzbx9aOuqGU9ZEzk5eGuDSSSJpxXPZ_45AI5JF5MMMeta || {},
    component: () => import("/vercel/path0/app/pages/leistungen.vue")
  },
  {
    name: "referenzen",
    path: "/referenzen",
    meta: referenzenjLVV7mK3m_45Phy7xTTeViUW35BzKseBvL1MdB0qRSEL0Meta || {},
    component: () => import("/vercel/path0/app/pages/referenzen.vue")
  },
  {
    name: "datenschutz",
    path: "/datenschutz",
    meta: datenschutz6OJtqLa28KpB6JIiElYAAcZ1vKHXBOpzFdze8UySUtMMeta || {},
    component: () => import("/vercel/path0/app/pages/datenschutz.vue")
  }
]